'use strict';

/**
 * TODO: migrate this to a dynamic/custom form
 */
// import angular from 'angular';

export default class MemberFormCtrl {
  member = {
    name: ''
  };
  // Auth; //TODO: add auth check

  constructor($state, $stateParams, LoaderSvc, DatetimeSvc, MemberSvc,
    MemTypeSvc, MemAtrTypeSvc, GrpTypeSvc, GroupSvc, GroupAuthSvc) {
    var ctxId = $stateParams.ctxId;
    this.ctxId = ctxId;

    this.$state = $state;
    this.$stateParams = $stateParams;
    this.MemberSvc = MemberSvc;
    this.MemAtrTypeSvc = MemAtrTypeSvc;
    this.LoaderSvc = LoaderSvc;
    this.DatetimeSvc = DatetimeSvc;

    var selectAtrTypes = [];

    this.model = {
      start: new Date() // default to today
    };

    var that = this;
    this.isCreate = $state.current.name.toLowerCase().indexOf('new') !== -1;

    // form inputs
    this.rows = [
      {header: 'Group',
        inputs: []},
      {inputs: [{responseType: 'dropdown', name: 'Member Type',
        value: 'typeId',
        ngHide: '!memvm.memTypes || memvm.memTypes.length === 0',
        options: 'mt.id as mt.name for mt in memvm.memTypes',
        required: true, class: 'col-xs-6'
      },
      {responseType: 'date', name: 'Start', value: 'start',
        datepicker: true, required: true, class: 'col-xs-6',
        dateFormat: 'M/d/yyyy'
      }
      ]},
      {header: 'Personal Information',
        inputs: [
          {name: 'Prefix', value: 'prefix', class: 'col-xs-2'},
          {name: 'First Name', value: 'fname', required: true,
            class: 'col-xs-4'},
          {name: 'Last Name', value: 'lname', required: true,
            class: 'col-xs-4'},
          {name: 'Suffix', value: 'suffix', class: 'col-xs-2'},
        ]},
      {inputs: [{name: 'Preferred Name', value: 'preferredName'}]},
      {inputs: [{name: 'Email Address', value: 'email', inputType: 'email',
        class: 'col-xs-6'},
      {name: 'Phone Number', value: 'number', class: 'col-xs-6'}]},
      {inputs: [{name: 'Address', value: 'line', required: true,
        class: 'col-xs-6'},
      {name: 'City/Town', value: 'locality', required: true,
        class: 'col-xs-6'}]},
      {inputs: [{name: 'State/Region', value: 'region', required: true,
        class: 'col-xs-4'},
      {name: 'Postal Code', value: 'postalCode', required: true,
        class: 'col-xs-4'},
      {name: 'Country', value: 'country', class: 'col-xs-4'}]}
    ];

    this.rows.map(function(r) {
      r.displayOrder = -1;
      return r;
    });

    // create
    if(this.isCreate) {
      that.LoaderSvc.start();

      this.submit = this.createMember;
      that.headerText = 'New Member';
      that.submitText = 'Create Member';
      this.cancelSref = 'group.memberList';

      var groupId = ctxId;

      // authorization
      GroupAuthSvc.validatePermission(groupId, 'member', 'C');

      //////////////////////////////////////////////////////////////////////////
      // Member Types
      //////////////////////////////////////////////////////////////////////////
      MemTypeSvc.getDefinedFor({groupId}).$promise
        .then(function(memTypes) {
        // filter and default member types
          that.memTypes = memTypes.filter(function(mem) {
            if(mem.isDefaultNewMemForm) {
              that.model.typeId = mem.id;
            }
            return mem.includeInNewMemForm;
          });
        });

      //////////////////////////////////////////////////////////////////////////
      // Member Attributes
      //////////////////////////////////////////////////////////////////////////
      var memAtrTypes = [];
      MemAtrTypeSvc.query({groupId}).$promise
        .then(function(memAtrType) {
        // filter and map member attributes
          memAtrType = memAtrType.filter(function(mat) {
            return mat.includeInNewMemForm;
          }).map(function(mat) {
            mat.value = 'a' + mat.id;
            memAtrTypes.push(mat.value);
            mat.min = mat.minNewMember;
            return {inputs: [mat], displayOrder: mat.displayOrder};
          });
          that.memAtrTypes = memAtrTypes;
          // update form object
          if(memAtrType.length > 0) {
            that.rows.push({header: 'Member Information', displayOrder: -1});
          }
          that.rows = that.rows.concat(memAtrType);

          // get select options for relationship attributes
          for(var i in memAtrType) {
          // one input per row
            var mat = memAtrType[i].inputs[0];
            /**
           * TODO: remove default of disabled attributes
           */
            if(mat.isAutoIncrement) {
            // mat.ngIf = false;
            } else if(mat.responseType === 'rel') {
              selectAtrTypes.push(mat);
              // default model
              if(!that.model[mat.value]) {that.model[mat.value] = [];}
              if(mat.min) {
                for(var j = 1; j <= mat.min; j++) {
                  that.model[mat.value].push({});
                }
              }
            }
          }
          return null;
        })
        .then(function() {
        /**
         * TODO: convert to promise map/mapSeries to include multiple
         */
          // get select options
          for(var j in selectAtrTypes) {
            var sat = selectAtrTypes[j];
            MemAtrTypeSvc.getOptions({groupId, id: sat.id}).$promise
              .then(function(options) { // eslint-disable-line no-loop-func
                sat.selectOptions = options;
              });
          }
        });
      //////////////////////////////////////////////////////////////////////////
      // Groups
      //////////////////////////////////////////////////////////////////////////
      var groupTypes = {}; // store groups by groupType
      GrpTypeSvc.getDesc({groupId}).$promise
        .then(function(gt) {
          if(gt.length === 0) {that.model.groupId = groupId; }
          gt.map(function(type) {
            groupTypes[type.id] = {type, isLeaf: true, groups: []};
            return type;
          }).map(function(type) {
            // remove isLeaf flag from referenced parent groups
            // leaf groups are set as required
            if(type.parentId && groupTypes[type.parentId]) {
              groupTypes[type.parentId].isLeaf = false;
            }
            return type;
          });

          return (async function() {
            for(const type of gt) {
              await GroupSvc.query({groupId, groupTypeId: type.id}).$promise
                .then(function(groups) {
                  groupTypes[type.id].groups = groups;
                  var optionStr
                    = 'grp.id as grp.name for grp in (memvm.groupTypes['
                    + type.id + '].groups | orderBy:"name")';
                  if(type.parentId) {
                    optionStr += ' | filter: {parentId: memvm.model.g'
                    + type.parentId + '}';
                  }

                  // for admins, no requirement on groups
                  var isAdmin = GroupAuthSvc.hasPermission(
                    groupId, 'member', 'A'
                  );

                  that.rows[0].inputs.push({
                    responseType: 'dropdown', name: type.name,
                    value: 'g' + type.id,
                    options: optionStr,
                    required: isAdmin ? false : !groupTypes[type.id].isLeaf,
                    class: 'col-xs-6',
                    displayOrder: type.path
                  });
                  return null;
                });
            }
            that.groupTypes = groupTypes;
          }());
        }).then(function() {
          that.LoaderSvc.stop();
        });

      // GroupSvc.query({groupId, groupTypeId: typeId}).$promise
      // .then(function(groups) {
      //   return groups;
      // });
    // // edit
    // } else {
    //   this.submit = this.updateMember;
    //   var personId = $stateParams.perId;
    //   this.personId = personId;
    //   that.headerText = 'Edit Member';
    //   that.submitText = 'Update Member';
    //   this.MemberSvc.get({groupId: ctxId, personId}).$promise
    //   .then(function(mt) {
    //     mt.amount = mt.amount / 100; // cents
    //     that.model = angular.copy(mt);
    //     that.display = mt;
    //   });
    //   this.cancelSref = 'group.memberList';
    }
  }

  createMember() {
    var that = this;
    that.LoaderSvc.start();
    var model = that.model;
    var reqParams = {
      person: {},
      membership: {},
      memAtr: {}
    };

    // person
    var personAtr = ['prefix', 'fname', 'lname', 'suffix', 'preferredName'];
    for(var i in personAtr) {
      var pa = personAtr[i];
      if(typeof model[pa] !== 'undefined') { reqParams.person[pa] = model[pa]; }
    }
    if(model.email) { reqParams.person.emails = {email: model.email}; }
    if(model.number) { reqParams.person.numbers = {number: model.number}; }
    reqParams.person.addresses = [{
      lines: [model.line],
      locality: model.locality,
      region: model.region,
      postalCode: model.postalCode,
      country: model.country
    }];

    // membership
    var leafGroupId;
    var nodeGroupId;
    for(var gid in that.groupTypes) {
      var gt = that.groupTypes[gid];
      if(gt.isLeaf && model['g' + gid]) {
        leafGroupId = model['g' + gid];
      } else if(model['g' + gid]) {
        // first node defined
        // NOTE: assumes sorted by groupType
        nodeGroupId = model['g' + gid];
      }
    }
    // prioritize for leaf group, then work up tree;
    var memGroupId = leafGroupId || nodeGroupId || that.groupId || that.ctxId;
    reqParams.membership = {
      group: {id: memGroupId},
      start: that.DatetimeSvc.getDatePropString(model.start),
      typeId: model.typeId
    };


    // member attributes
    for(var j in that.memAtrTypes) {
      var ma = that.memAtrTypes[j];
      if(model[ma]) {reqParams.memAtr[ma] = model[ma];}
    }

    return that.MemberSvc.save({groupId: memGroupId}, reqParams).$promise
    // var reqParams = {
    //   groupId: that.ctxId,
    //   personId: that.personId
    // };
    // that.MemberSvc.create(reqParams, model).$promise
      .then(function(mem) {
        that.LoaderSvc.stopSuccess('Member Created');
        if(mem.person && mem.person.id) {
          that.$state.go('group.memberView.membership', {perId: mem.person.id});
        } else {
          that.$state.go('group.memberList');
        }
        return null;
      }).catch(function(err) {
        that.LoaderSvc.stop();
        throw err;
      });
  }

  // updateMember() {
  //   var that = this;
  //   that.LoaderSvc.start();
  //   // remove rels that cannot be edited
  //   var model = this.model;
  //   delete model.mtDefBy;
  //   delete model.timePeriod;
  //   delete model.mtMemType;
  //   model.amount = model.amount * 100; // cents
  //   var reqParams = {
  //     groupId: that.ctxId,
  //     personId: that.personId,
  //     id: that.mtId
  //   };
  //   this.MemberSvc.update(reqParams, model).$promise.then(function() {
  //     that.$state
  //     .go('group.memberView', {mtId: that.mtId});
  //     that.LoaderSvc.stopSuccess('Member Updated');
  //   })
  //   .catch(function(err) {
  //     that.LoaderSvc.stopError(err);
  //   });
  // }
}

MemberFormCtrl.$inject = [
  '$state',
  '$stateParams',
  'LoaderSvc',
  'DatetimeSvc',
  'MemberSvc',
  'MemTypeSvc',
  'MemAtrTypeSvc',
  'GrpTypeSvc',
  'GroupSvc',
  'GroupAuthSvc'
];
